import { render, staticRenderFns } from "./PropertySelector.vue?vue&type=template&id=5ea38292&scoped=true&"
import script from "./PropertySelector.vue?vue&type=script&lang=ts&"
export * from "./PropertySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea38292",
  null
  
)

export default component.exports